<div>
	<div nz-row nzJustify="space-between" [ngClass]="{'m-b-24':isMobile}">
		<ng-container *ngIf="isMobile">
			<div nz-col nzSpan="24" class="align-center addCursor display-flex" (click)="goBack()">
				<svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path
						d="M17.8127 8.3129H4.54837L10.3434 2.5179C10.8065 2.05478 10.8065 1.29478 10.3434 0.831652C10.2335 0.721567 10.103 0.634229 9.95936 0.574638C9.81571 0.515048 9.66171 0.484375 9.50618 0.484375C9.35066 0.484375 9.19666 0.515048 9.053 0.574638C8.90935 0.634229 8.77886 0.721567 8.669 0.831652L0.843371 8.65728C0.733286 8.76714 0.645948 8.89763 0.586358 9.04129C0.526767 9.18494 0.496094 9.33894 0.496094 9.49447C0.496094 9.64999 0.526767 9.80399 0.586358 9.94764C0.645948 10.0913 0.733286 10.2218 0.843371 10.3317L8.669 18.1573C8.77894 18.2672 8.90946 18.3544 9.0531 18.4139C9.19674 18.4734 9.3507 18.5041 9.50618 18.5041C9.66166 18.5041 9.81562 18.4734 9.95927 18.4139C10.1029 18.3544 10.2334 18.2672 10.3434 18.1573C10.4533 18.0473 10.5405 17.9168 10.6 17.7732C10.6595 17.6295 10.6901 17.4756 10.6901 17.3201C10.6901 17.1646 10.6595 17.0107 10.6 16.867C10.5405 16.7234 10.4533 16.5928 10.3434 16.4829L4.54837 10.6879H17.8127C18.4659 10.6879 19.0002 10.1535 19.0002 9.5004C19.0002 8.84728 18.4659 8.3129 17.8127 8.3129Z"
						fill="#0361F0" />
				</svg>
				<span class="m-l-16 f-s-12 font-bold">Beneficiaries</span>
			</div>
			<div *ngIf="isMobile" nz-col nzSpan="24"
				class="m-t-20 font-bold text-[24px] leading-[29px] text-dark-purple">
				{{ currentStep == MANAGE_BENEFICIARIES ? 'Manage Beneficiaries' : 'Add Beneficiary' }}
			</div>
		</ng-container>
		<ng-container *ngIf="!isMobile">
			<div>
				<div>
					<span class="font-bold text-[24px] leading-[29px]">
						Manage Beneficiaries
					</span>
				</div>
				<div class="m-t-8">
					<app-moniepoint-breadcrumb (goBack)="goBack()" basePage="Beneficiaries"
						currentPage="Manage Beneficiaries">
					</app-moniepoint-breadcrumb>
				</div>
			</div>
		</ng-container>
		<div class="manage-bene" *ngIf=" currentStep == MANAGE_BENEFICIARIES">
			<ng-container *ngIf="!isMobile">
				<app-custom-button prefix="plus" text="Add Beneficiary" (click)="launchAddBeneficiaryModal()"
					type="default"></app-custom-button>
			</ng-container>
			<ng-container *ngIf="isMobile">
				<div class="fab-shadow fixed bottom-[32px] z-20 right-0">
					<app-custom-button prefix="plus" [state]="'primary'" (click)="currentStep=ADD_BENEFICIARY"
						shape="round" [text]="'Add Beneficiary'" prefix="plus"></app-custom-button>
				</div>
			</ng-container>
		</div>
	</div>
	<div class="mobile-margin-less" [ngClass]="{'bg-empty-scr-grey rounded-r-lg m-t-32':!isMobile}">
		<div [ngSwitch]="currentStep">
			<div *ngSwitchCase="MANAGE_BENEFICIARIES">
				<div *ngIf="!isMobile" class="w-500P m-auto p-t-32">
					<span class="font-bold text-[24px] leading-[29px]">
						Manage Beneficiaries
					</span>
				</div>
				<div [ngClass]="{'w-500P min-h-[600px] m-auto pb-[32px]':!isMobile}">
					<div class="m-t-24">
						<div class="custom-floating-input m-t-24 m-b-16" [ngClass]="{'m-b-20':!isMobile}">
							<nz-input-group [nzPrefix]="searchIcon">
								<input [(ngModel)]="searchParams" class="custom-input filter-banks-input" id="account"
									nz-input placeholder="Search By Beneficiary Name" type="text"
									[nzBorderless]="true" />
							</nz-input-group>
						</div>
					</div>
					<div>
						<div *ngIf="beneficiaries.length" class="max-h-[526px] overflow-y-scroll">
							<div (click)="selectedBeneficiary(beneficiary)"
								*ngFor="let beneficiary of beneficiaries|searchFilter:searchParams:'beneficiaryName';let k = index"
								class="addCursor">
								<div class="beneficiary-row-bill-payment" nz-row nzAlign="middle"
									nzJustify="space-between">
									<div class="flex" nz-col nzSpan="22">
										<div
											class="flex justify-center bg-bg-color-lighter-blue items-center rounded-lg font-bold f-20 name text-primary">
											{{getInitials(beneficiary?.beneficiaryName)}}
										</div>
										<div class="m-l-20 break-all self-center">
											<div class="f-14 font-semibold">
												{{beneficiary?.beneficiaryName}}
											</div>
											<div class="text-primary-desc-color f-s-12 font-normal">
												{{beneficiary?.customerIdName}}: {{beneficiary?.customerIdValue}}
											</div>
										</div>
									</div>

									<div nz-col nzSpan="2" class="flex justify-end cor-p" (click)="deleteBeneficiary(beneficiary)">
										<app-grey-icon [greyIcon]="'grey-delete'"></app-grey-icon>
									</div>
								</div>
								<div *ngIf="(beneficiaries?.length - 1) !== k ">
									<div class="bill-payment-divider" [ngClass]="{'m-b-20':!isMobile}"></div>
								</div>

							</div>
						</div>
					</div>
				</div>
			</div>
			<div *ngSwitchCase="ADD_BENEFICIARY">
				<app-add-beneficiary [form]="form" [accountNoControl]="accountNoControl"
					(openBanksFormEmmiter)="openBanksForm()"></app-add-beneficiary>
			</div>
			<div *ngSwitchCase="BENEFICIARY_SUMMARY">
				<div nz-row nzJustify="space-between" class="flex-col min-mobile-height">
					<div nz-col nzSpan="24" class="align-center flex rounded-lg m-t-32 border-zinc-300 border p-4">
						<div class="flex" nz-col nzSpan="22">
							<div
								class="flex justify-center bg-bg-color-lighter-blue items-center rounded-lg font-bold f-20 name text-primary">
								{{getInitials(beneficiaryDetails?.recipientAccountName)}}
							</div>
							<div class="m-l-20 break-all self-center">
								<div class="f-14 font-semibold">
									{{beneficiaryDetails?.recipientAccountName}}
								</div>
								<div class="text-primary-desc-color f-s-12 font-normal">
									{{beneficiaryDetails?.bankName}}: {{beneficiaryDetails?.accountNo}}
								</div>
							</div>
						</div>

						<div nz-col nzSpan="2" class="flex justify-end f-s-12 text-primary cursor-pointer">
							
						</div>
					</div>
					<div nz-col nzSpan="24">
						<div nz-row class="bill-payment-divider"></div>
						<div nz-row class="full-w-btn m-b-24">
							<div nz-col nzSpan="12">
								<app-custom-button text="Cancel" type="link" (click)="cancelBeneficiary()"></app-custom-button>
							</div>
							<div nz-col nzSpan="12">
								<app-custom-button text="Save" type="default" (click)="savebeneficiary(beneficiaryDetails)"></app-custom-button>
							</div>

						</div>
					</div>
				</div>

			</div>
		</div>

	</div>
</div>
<ng-template #searchIcon>
	<svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M21.9073 19.7527L17.4969 15.3422C18.5587 13.9286 19.1319 12.208 19.13 10.44C19.13 5.92406 15.4559 2.25 10.94 2.25C6.42406 2.25 2.75 5.92406 2.75 10.44C2.75 14.9559 6.42406 18.63 10.94 18.63C12.708 18.6319 14.4286 18.0587 15.8422 16.9969L20.2527 21.4073C20.4759 21.6069 20.7671 21.7135 21.0664 21.7051C21.3658 21.6967 21.6506 21.574 21.8623 21.3623C22.074 21.1506 22.1967 20.8658 22.2051 20.5664C22.2135 20.2671 22.1069 19.9759 21.9073 19.7527ZM5.09 10.44C5.09 9.28298 5.4331 8.15194 6.0759 7.18991C6.71871 6.22789 7.63235 5.47808 8.7013 5.03531C9.77025 4.59253 10.9465 4.47668 12.0813 4.70241C13.2161 4.92813 14.2584 5.48529 15.0766 6.30343C15.8947 7.12156 16.4519 8.16393 16.6776 9.29872C16.9033 10.4335 16.7875 11.6098 16.3447 12.6787C15.9019 13.7476 15.1521 14.6613 14.1901 15.3041C13.2281 15.9469 12.097 16.29 10.94 16.29C9.38906 16.2881 7.90217 15.6712 6.80548 14.5745C5.7088 13.4778 5.09186 11.9909 5.09 10.44Z"
			fill="#0B3275" fill-opacity="0.4" />
	</svg>
</ng-template>